import {
  createArTableStore,
  type ColumnConfig,
  type SortEntry,
} from "@/components/ui/ar-table";

export type { ColumnConfig, SortEntry };

export const DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: "select", label: "Select", visible: true, position: 0, width: 40 },
  { id: "name", label: "Name", visible: true, position: 1, width: 220 },
  { id: "contact", label: "Contact", visible: true, position: 2, width: 200 },
  { id: "socials", label: "Socials", visible: true, position: 3, width: 100 },
  { id: "stage", label: "Stage", visible: true, position: 4, width: 130 },
  { id: "in_stage", label: "In Stage", visible: true, position: 5, width: 110 },
  { id: "sync", label: "ATS", visible: true, position: 6, width: 140 },
  { id: "sequences", label: "Sequences", visible: true, position: 7, width: 150 },
  { id: "job_title", label: "Job Title", visible: true, position: 8, width: 200 },
  { id: "company", label: "Company", visible: true, position: 9, width: 180 },
  { id: "location", label: "Location", visible: true, position: 10, width: 180 },
  { id: "education", label: "Education", visible: true, position: 11, width: 180 },
  { id: "added_at", label: "Added", visible: true, position: 12, width: 120 },
];

export const FIXED_COLUMNS = new Set(["select"]);
export const STICKY_COLUMNS = new Set(["select", "name"]);

export const usePipelineTableStore = createArTableStore({
  defaultColumns: DEFAULT_COLUMNS,
  persistKey: "arbi-pipeline-store",
  fixedColumns: FIXED_COLUMNS,
  stickyColumns: STICKY_COLUMNS,
  defaultSorts: [{ column: "added_at", order: "desc" }],
  // Renamed from the misleading "email" id; carry over existing users' saved
  // sizing/visibility for that column.
  columnAliases: { email: "contact" },
});
